import styles from './product-detail.module.scss';
import sectionList from '../../../Data/Sections.json';
import Footer from '../../../Components/Footer/Footer';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ImagePresentation from '../../../Components/ImagePresentation/ImagePresentation';
import { formatCurrency } from '../../../Utilities/Utilities';
import Loader from '../../../Components/Loader/Loader';
import SizeDisplay from '../../../Components/SizeDisplayer/SizeDisplay';

const ProductDetail = () => {
    const { id, product } = useParams();
    const [currentBrand, setCurrentBrand] = useState(null);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 300);
    }, [id]);

    useEffect(() => {
        const brand = sectionList.find((b) => b.id === id);

        if (!brand) return;

        setCurrentBrand(brand);

        const foundProduct = brand.products.find((p) => p.id.toLowerCase() === product);

        setCurrentProduct(foundProduct || null);
    }, [id, product]);

    if (!currentProduct) return null;

    return (
        <>
            <div className={styles.placeholder} />
            {loading ? (
                <Loader />
            ) : (
                <div className={styles.container}>
                    <ImagePresentation images={currentProduct.photos || []} />
                    <div className={styles.productDetail}>
                        <h1>{currentBrand.brand}</h1>
                        <h2>{currentProduct.name}</h2>
                        <p>{formatCurrency(currentProduct.price)}</p>
                        {currentProduct.sizes ?
                            <div>
                                <h4>Select Sizes</h4>
                                <SizeDisplay sizes={currentProduct.sizes} />
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default ProductDetail;
